export enum EnumerationItemFields {
  enumerationValue = 'enumerationValue',
  enumerationGroup = 'enumerationGroup',
  simpleText = 'simpleText',
  displayText = 'displayText',
  fullDescription = 'fullDescription',
  fullyqualifiedUrn = 'fullyqualifiedUrn',
}
